import React, { createRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const NotificationBellIcon = ({ isActive = false, isNotify = false, width, height, cursor, handleClickNotification }) => {
    const pathRef = createRef()
    const pathRef2 = createRef()
    useEffect(() => {
        if (pathRef?.current) {
            pathRef.current.style.fill = isActive ? '#0657AE' : '#444444'
            const notifyFill = () => {
                if (isNotify) {
                    return '#BE3144'
                } else if (isActive && !isNotify) {
                    return '#0657AE'
                } else {
                    return '#444444'
                }
            }
            pathRef2.current.style.fill = notifyFill()
        }
    }, [ isActive, isNotify ])
    return (
        <svg xmlns="http://www.w3.org/2000/svg" onClick={handleClickNotification} style={{ cursor }} width="37" height="36" viewBox="0 0 37 36" fill="none">
            <path d="M18.353 33C17.5118 33 16.792 32.7065 16.1934 32.1195C15.5949 31.5325 15.2952 30.826 15.2941 30H21.4118C21.4118 30.825 21.1125 31.5315 20.514 32.1195C19.9155 32.7075 19.1952 33.001 18.353 33ZM6.11768 28.5V25.5H9.1765V15C9.1765 12.925 9.81375 11.0815 11.0883 9.4695C12.3628 7.8575 14.0196 6.801 16.0589 6.3V5.25C16.0589 4.625 16.2821 4.094 16.7287 3.657C17.1753 3.22 17.7167 3.001 18.353 3C18.9902 3 19.5321 3.219 19.9787 3.657C20.4253 4.095 20.6481 4.626 20.6471 5.25V5.7375C20.3667 6.2875 20.1628 6.85 20.0353 7.425C19.9079 8 19.8569 8.5875 19.8824 9.1875C19.6275 9.1375 19.3787 9.0935 19.136 9.0555C18.8934 9.0175 18.6323 8.999 18.353 9C16.6706 9 15.2304 9.5875 14.0324 10.7625C12.8343 11.9375 12.2353 13.35 12.2353 15V25.5H24.4706V15.8625C24.9294 16.0625 25.4204 16.219 25.9434 16.332C26.4665 16.445 26.9952 16.501 27.5294 16.5V25.5H30.5883V28.5H6.11768ZM27.5294 13.5C26.2549 13.5 25.1716 13.0625 24.2794 12.1875C23.3873 11.3125 22.9412 10.25 22.9412 9C22.9412 7.75 23.3873 6.6875 24.2794 5.8125C25.1716 4.9375 26.2549 4.5 27.5294 4.5C28.804 4.5 29.8873 4.9375 30.7794 5.8125C31.6716 6.6875 32.1177 7.75 32.1177 9C32.1177 10.25 31.6716 11.3125 30.7794 12.1875C29.8873 13.0625 28.804 13.5 27.5294 13.5Z" fill="#444444"/>
            <path fill={!isNotify ? 'hsl(var(--secondary))' : 'hsl(var(--danger))' } d="M23.9183 12.5417C24.9096 13.5139 26.1133 14 27.5294 14C28.9456 14 30.1493 13.5139 31.1405 12.5417C32.1318 11.5694 32.6275 10.3889 32.6275 9C32.6275 7.61111 32.1318 6.43056 31.1405 5.45833C30.1493 4.48611 28.9456 4 27.5294 4C26.1133 4 24.9096 4.48611 23.9183 5.45833C22.927 6.43056 22.4314 7.61111 22.4314 9C22.4314 10.3889 22.927 11.5694 23.9183 12.5417Z" />
        </svg>
    )
}

NotificationBellIcon.propTypes = {
    isActive: PropTypes.bool,
    isNotify: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
    cursor: PropTypes.string
}

export default NotificationBellIcon
